import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService, UserService } from '@lru/felib';
import { IBookLocationSave } from '@portal-app/interfaces/book/project/book-location.interface';
import { ReplaySubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { INextBook } from '../../interfaces/book/next/next-book';
import { AppInitService } from '../shared/app-init.service';

@Injectable({
  providedIn: 'root',
})
export class BookContinueService {
  private data = new ReplaySubject<INextBook[]>(1);
  data$ = this.data.asObservable();

  constructor(
    private apiService: ApiService,
    private userService: UserService,
    private appInitService: AppInitService
  ) {}

  private loaded = false;
  initialize() {
    const subject = new ReplaySubject<boolean>(1);
    if (!this.loaded) {
      this.fetchAndUpdate().subscribe(
        (data) => {
          if (data) {
            subject.next(true);
            this.loaded = true;
          } else {
            subject.next(false);
          }
        },
        (error: HttpErrorResponse) => {
          subject.next(false);
        }
      );
    } else {
      subject.next(true);
    }
    return subject;
  }

  fetchAndUpdate() {
    const subject = new ReplaySubject<boolean>(1);
    if (this.userService.isLoggedIn && (this.appInitService.isSuperbog || this.appInitService.isSuperreader)) {
      this.apiService
        .getNext<INextBook[]>(
          `Book/GetBooksInProgress?projectGroupId=${this.appInitService.siteConfiguration.ProjectGroup}`
        )
        .subscribe(
          (data) => {
            this.data.next(data || []);
            subject.next(true);
          },
          (error: HttpErrorResponse) => {
            subject.next(false);
          }
        );
    } else {
      subject.next(false);
    }
    return subject;
  }

  setBookContinue(bookId: string, progress: string, percentage: number) {
    const body: IBookLocationSave = {
      BookId: bookId,
      Progress: progress,
      Percentage: percentage,
    };
    return this.apiService.postNext<string>(`BookProgress/SaveProgress`, body).pipe(
      map((result: string) => {
        this.fetchAndUpdate();
        return result;
      })
    );
  }
}
